import { useWorkflowStore } from "../stores/workflow-store"

type LoopProgress = {
  current: number
  total: number
}

type NodeExecutionState = {
  isExecuting: boolean
  isCompleted: boolean
  isTestRunActive: boolean
  output: string | undefined
  loopProgress: LoopProgress | undefined
}

export function useNodeExecutionState(nodeId: string): NodeExecutionState {
  const isTestRunActive = useWorkflowStore((state) => state.isExecuting)
  const executingNodeIds = useWorkflowStore((state) => state.executingNodeIds)
  const completedNodeIds = useWorkflowStore((state) => state.completedNodeIds)
  const nodeOutputs = useWorkflowStore((state) => state.nodeOutputs)
  const loopProgressMap = useWorkflowStore((state) => state.loopProgress)

  return {
    isExecuting: executingNodeIds.includes(nodeId),
    isCompleted: completedNodeIds.includes(nodeId),
    isTestRunActive,
    output: nodeOutputs[nodeId],
    loopProgress: loopProgressMap[nodeId],
  }
}
